import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { WorkSchedule } from '@app/models/time-off-v3/works-schedule.model';
import { WorkScheduleMenuService } from '@app/modules/time-off-v3/services/menus/work-schedules-menu.service';
import { NotifyService } from '@app/services';

@Component({
    templateUrl: './work-schedules-enrolled-employees.template.html',
    styleUrls: ['./work-schedules-enrolled-employees.style.scss'],
})
export class WorkSchedulesEnrolledEmployeesView {
    @ViewChild('workScheduleDeleteModal') workScheduleDeleteModal: DeprecatedConfirmationDialogComponent;

    isLoading = false;
    workSchedule: WorkSchedule = new WorkSchedule();

    constructor(
        private notify: NotifyService,
        private router: Router,
        private route: ActivatedRoute,
        public tabMenuService: WorkScheduleMenuService
    ) {
        this.workSchedule = this.route.snapshot.data.models.get('work-schedule');
    }

    async deleteWorkSchedule(): Promise<void> {
        const approved = await this.workScheduleDeleteModal.show();

        if (!approved) {
            return;
        }

        await this.workSchedule.delete();
        this.router.navigate(['time-off', 'v3', 'settings']);
        this.notify.success('time-off-v3.workScheduleDeletedSuccessfully');
    }
}
